<template>
  <header class="header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-10">
          <div class="header__logo">
            <router-link to="/">
              <img
                src="@/assets/logo.png"
                alt="KGB Aviation"
              >
            </router-link>
          </div>
          <nav class="header__nav d-none d-lg-inline-flex">
            <navigation-menu v-if="$store.getters.isAuthorized" />
          </nav>
        </div>
        <div class="col-2 d-none d-lg-block text-right">
          <header-buttons />
        </div>
        <div class="col-4 col-sm-5 d-lg-none text-right">
          <off-canvas-menu />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import NavigationMenu from '@/components/NavigationMenu.vue';
import HeaderButtons from '@/components/HeaderButtons.vue';
import OffCanvasMenu from '@/components/OffCanvasMenu.vue';

export default {
  name: 'Header',
  components: {
    NavigationMenu,
    HeaderButtons,
    OffCanvasMenu,
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: $header-height;
  background: $white;
  border-bottom: $default-border;

  & .header__nav {
    width: calc(100% - 150px);
    height: 100%;
  }

  &__logo {
    display: inline-block;
    height: $header-height;
    vertical-align: top;

    img {
      width: 150px;
      height: auto;
      padding-top: 19px;
    }
  }

  /deep/ &__nav {
    display: inline-block;
    vertical-align: top;

    ul {
      display: flex;
      flex: 1;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      margin: 0;
      list-style-type: none;

      li {
        display: inline-block;
        margin-right: $gutter;

        a,
        .link {
          color: $default-font;
          text-decoration: none;

          &:hover {
            color: $highlight-color;
          }

          &.router-link-active {
            color: $highlight-color;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
